import { useTranslation } from "react-i18next";
import { PA_NAME } from "../../types/product-attribute/product-attribute";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";

export const BookingCardProdaText = ({
  pickedDto,
  bookingAttributes,
  vari = "BLUE",
}: {
  pickedDto: BookingAttributeDTO;
  bookingAttributes: BookingAttributeDTO[];
  vari: "GRAY" | "BLUE";
}) => {
  const { t } = useTranslation();
  const name = pickedDto.productAttribute.name;
  const value = pickedDto.value;
  const className =
    vari === "GRAY"
      ? "text-[0.875rem] text-[#5E6D77] leading-[1.375rem] font-normal"
      : "text-[0.875rem] text-[#6790AC] leading-[1.5rem] font-normal";

  const renderCalendar = () => {
    if (PA_NAME.CALENDAR.includes(name as ProdAttrNameCalendar)) {
      const duration = bookingAttributes?.find(
        (x) => x.productAttribute.name === "DURATION",
      )?.productAttribute?.value;
      console.log(bookingAttributes);
      return (
        <p className={className}>
          {name === "ESIM_CALENDAR" ? t("Activation date") + ": " : ""}
          {ProdAttrUtils.dpDateTime(value, duration)}
        </p>
      );
    }
    return null;
  };

  const renderThirdPartyValue = () => {
    if (PA_NAME.PARTY_3RD.includes(name as ProdAttrName3rdParty)) {
      try {
        const musicalTicketName =
          pickedDto.value?.extProductBookingValues?.[0]?.dpName ?? "";
        return <p className={className}>{musicalTicketName}</p>;
      } catch (e) {}
    }
    return null;
  };

  const renderSimDetails = () => {
    if (name === "SIM" && value?.simProductInfo) {
      return (
        <>
          {!!value?.simProductInfo?.eid && (
            <p className={className}>
              {t("EID")}: {value.simProductInfo.eid}
            </p>
          )}
          {!!value?.simProductInfo?.imei && (
            <p className={className}>
              {t("IMEI")}: {value.simProductInfo.imei}
            </p>
          )}
        </>
      );
    }
    if (name === "SIM" && pickedDto.value?.quantity) {
      const [d, v] = (pickedDto.productAttribute.value ?? "").split("_");

      return (
        <>
          {!!(d && v) && (
            <>
              <p className={className}>
                {t("SIM validity")}:{" "}
                {ProdAttrUtils.SIM.dpValidity(v)
                  .map((x) => t(x))
                  .join(" ")}
              </p>
              <p className={className}>
                {t("Data package")}:{" "}
                {ProdAttrUtils.SIM.dpDataPackage(d)
                  .map((x) => t(x))
                  .join(" ")}
              </p>
              <p className={className}>
                {t("Quantity")}: {pickedDto.value?.quantity}
              </p>
            </>
          )}
        </>
      );
    }
    return null;
  };

  const renderQuantityBased = () => {
    if (value?.quantity) {
      if (["LUGGAGE"].includes(name as ProdAttrName)) {
        return (
          <p className={className}>
            {t("Luggage")}: {pickedDto?.productAttribute?.value ?? ""}
          </p>
        );
      }
      if (PA_NAME.CHECKBOX.includes(name as ProdAttrNameSingleCheckbox)) {
        return (
          <p className={className}>
            {pickedDto?.productAttribute?.value ?? ""}
          </p>
        );
      }
    }
    return null;
  };

  const renderTextBased = () => {
    if (value?.text) {
      if (["DROP_OFF_LOCATION"].includes(name as ProdAttrName)) {
        return <p className={className}>{pickedDto?.value?.text ?? ""}</p>;
      }
    }

    return null;
  };

  return (
    renderCalendar() ||
    renderThirdPartyValue() ||
    renderSimDetails() ||
    renderQuantityBased() ||
    renderTextBased() ||
    null
  );
};
